import * as React from 'react';
import Utils from '../Utils';

const styles = {
    videoWrapper : {
        position: 'relative',
        paddingBottom : '56.25%',
        paddingTop: '25px',
        height: 0,
    },
    instaWrppaer : {
        position: 'relative',
        paddingBottom : '140%',
        paddingTop: '25px',
        height: 0,
    },
    iframe : {
        position: 'absolute',
        top: '5%',
        left: 0,
        width: '100%',
        height: '80%',
    },
};

interface Props {
    params?: any;
    peek?: any;
}

class PeekView extends React.Component<Props, {}> {
    render() {
        const params = this.props.params;
        let content;

        if (params) {
            switch (params.type) {
                case 'facebook':
                    content = (
                        <div style={styles.videoWrapper}>
                            <iframe src={'https://www.facebook.com/video/embed?video_id=' + params.id}
                                width='500' height='280' style={styles.iframe}
                                scrolling='no' frameBorder='0' allowTransparency={true}/>
                            {/*<iframe src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ffacebook%2Fvideos%2F10153231379946729%2F&width=500&show_text=false&appId=646169548882057&height=280"
                                width="500" height="280" style={styles.iframe}
                                scrolling="no" frameBorder="0" allowTransparency={true}></iframe>*/}
                        </div>
                    );
                    break;
                case 'youtube':
                    content = (
                        <div style={styles.videoWrapper}>
                            <iframe style={styles.iframe} width='560' height='349'
                                src={'https://www.youtube.com/embed/' + params.id + '?autoplay=1'}
                                frameBorder='0' allowFullScreen={true} autoPlay={true}/>
                        </div>
                    );
                    break;
                case 'instagram':
                    content = (
                        <div style={styles.instaWrppaer}>
                            <iframe style={styles.iframe} width='560' height='349'
                                src={'//instagram.com/p/' + params.id + '/embed/?autoplay=1'}
                                frameBorder='0' allowFullScreen={true} autoPlay={true}/>
                        </div>
                    );
                    break;
                case 'youku':
                    content = (
                        <div style={styles.videoWrapper}>
                            <iframe style={styles.iframe} width='560' height='349'
                                src={'http://player.youku.com/embed/' + params.id }
                                frameBorder='0' allowFullScreen={true} autoPlay={true}/>
                        </div>
                    );
                    break;
                case 'native':
                    content = (
                        <div style={styles.videoWrapper}>
                            <iframe style={styles.iframe} width='560' height='349'
                                src={Utils.getParameterByName('url')}
                                frameBorder='0' allowFullScreen={true} autoPlay={true}/>
                        </div>
                    );
                    break;
            }
        }





        return (
            <div style={{width: '50%', margin:'auto'}}>
                {content}
            </div>
        );
    }
}

export default PeekView;



// WEBPACK FOOTER //
// ./src/components/PeekView.tsx